import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { WholesaleStateType, ApiGetDataStatus } from '@redux/types'
import { OrderType, WholesaleCatalogType, WholesaleOrderReqType } from '@schemas'

const initialState: WholesaleStateType = {
	catalog: null,
	catalogStatus: 'init',
	orderList: [],
	orderListStatus: 'init',
	isPlacing: false,
	placeResult: null,
	triggerInit: false,
	placeOrder: null,
}

/** 거래처 도매 주문 — persist 대상 아님(항상 서버에서 다시 읽는다) */
const slice = createSlice({
	name: 'wholesale',
	initialState,
	reducers: {
		TRIGGER_INIT_WHOLESALE_PAGE: (
			state: WholesaleStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInit = action.payload
		},
		CATALOG: (
			state: WholesaleStateType,
			action: PayloadAction<WholesaleCatalogType | null>,
		) => {
			state.catalog = action.payload
		},
		CATALOG_STATUS: (
			state: WholesaleStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.catalogStatus = action.payload
		},
		ORDER_LIST: (state: WholesaleStateType, action: PayloadAction<OrderType[]>) => {
			state.orderList = action.payload
		},
		ORDER_LIST_STATUS: (
			state: WholesaleStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.orderListStatus = action.payload
		},
		PLACE_ORDER: (
			state: WholesaleStateType,
			action: PayloadAction<WholesaleOrderReqType>,
		) => {
			state.placeOrder = action.payload
			state.isPlacing = true
			state.placeResult = null
		},
		IS_PLACING: (state: WholesaleStateType, action: PayloadAction<boolean>) => {
			state.isPlacing = action.payload
		},
		PLACE_RESULT: (
			state: WholesaleStateType,
			action: PayloadAction<WholesaleStateType['placeResult']>,
		) => {
			state.placeResult = action.payload
		},
	},
})

export const wholesaleActions = slice.actions
export default slice.reducer
